export const init = () => {
    const observer = new MutationObserver(() => {
        if (document.querySelector('.js-share-window')) {
            const shareWindows = document.querySelectorAll('.js-share-window');
            shareWindows.forEach((item) => {
                const linkInput = item.querySelector('.js-share-window-link');
                const linkButton = item.querySelector('.js-share-window-get-link-btn');
                const linkText = item.querySelector('.js-share-window-link-text');
        
                const getLinkText = linkText.textContent;
                const getLinkTextFired = linkText.dataset.fired;
                const getUrl = window.location.href;
                if (!linkInput.value) {
                    linkInput.value = getUrl;
                }
                linkButton.addEventListener('click', () => {
                    navigator.clipboard.writeText(linkInput.value)
                        .then(() => {
                            linkText.textContent = getLinkTextFired;
                            setTimeout(() => {
                                linkText.textContent = getLinkText;
                            }, 1500)
                        })
                        .catch(err => {
                            console.error('Chyba při kopírování hodnoty na schránku: ', err);
                        });
                });
            })
        }
    })
    observer.observe(document.body, {
        childList: true,
        //subtree: true
    });
};